<div class="form-group">
  @if (showLabel && question?.email_version) {
    <label [innerHtml]="question?.email_version"></label>
  }
  <div id="email-verify-form">
    <div class="form-group">
      <input
        type="email"
        [(ngModel)]="value"
        (ngModelChange)="onEmailChange()"
        required
        value=""
        [placeholder]="question?.question_prompt"
        [ngClass]="{'is-invalid': errorMessage}"
        class="form-control"
        id="emailAddress"
        name="emailAddress">
      </div>

      <div class="form-group mb-0">
        <input
          type="email"
          [(ngModel)]="verify"
          (ngModelChange)="emailExists()"
          required
          value=""
          placeholder="Confirm Email"
          [ngClass]="{'is-invalid': errorMessage}"
          class="form-control"
          id="verifyEmail"
          name="verifyEmail">
          @if (errorMessage) {
            <label class="form-control-error">{{ errorMessage }}</label>
          }
        </div>
      </div>
    </div>


